export default class AssetViewModel {
    id = null;
    organizationId = null;
    name = null;
    description = null;
    imagePath = null;
    isActive = false;
    teamsWebhookUrl = null;
    siteId = null;
    siteTitle = null;
    eTag = null;

    constructor(response){
        this.id = response.id;
        this.organizationId = response.organizationId;
        this.name = response.name;
        this.description = response.description;
        this.eTag = response.eTag;
        this.imagePath = response.imagePath;
        this.isActive = response.isActive;
        this.teamsWebhookUrl = response.teamsWebhookUrl;
        this.siteId = response.siteId;
        this.siteTitle = response.siteTitle;
    }
}
